import { FleekError } from './FleekError';

type FunctionFields = {
  name?: string;
  slug?: string;
};

type FleekFunctionAlreadyExistsErrorOptions = {
  function: FunctionFields;
};

export class FleekFunctionAlreadyExistsError extends FleekError<FleekFunctionAlreadyExistsErrorOptions> {
  public name = 'FleekFunctionAlreadyExistsError';

  toString = () => {
    if ('name' in this.data.function || 'slug' in this.data.function) {
      return `Function ${this.data.function.name || this.data.function.slug} already exists.`;
    }

    return `Unexpected Function data structure ${JSON.stringify(this.data.function)}`;
  };
}
